// extracted by mini-css-extract-plugin
export default {"reactSwitchCheckbox":"ToggleSwitch_reactSwitchCheckbox__Jg+63","reactSwitchLabel":"ToggleSwitch_reactSwitchLabel__1w1Rb","reactSwitchButton":"ToggleSwitch_reactSwitchButton__67Y-m"};